<template>
  <div class="what-is-module">
    <h2 class="what-is-title">What is GB WhatsApp?</h2>
    <p class="what-is-lead">
      <template v-for="(part, j) in introParts">
        <strong v-if="part.strong" :key="'s-' + j">{{ part.text }}</strong>
        <router-link v-else-if="part.link" :key="'l-' + j" :to="normalizeTo(part.link.to)">{{
          part.link.text
        }}</router-link>
        <span v-else :key="'t-' + j">{{ part.text }}</span>
      </template>
    </p>

    <figure v-if="bannerSrc" class="what-is-banner">
      <img
        :src="bannerSrc"
        :alt="bannerAlt"
        width="1200"
        height="675"
        loading="lazy"
        decoding="async"
        referrerpolicy="no-referrer"
        class="what-is-banner-img"
      />
    </figure>

    <ContentBlocks v-if="blocks && blocks.length" :blocks="blocks" class="what-is-follow" />
  </div>
</template>

<script>
import ContentBlocks from '@/components/gbwaps/ContentBlocks.vue';
import { withTrailingSlash } from '@/utils/route-path';

export default {
  name: 'WhatIsIntro',
  methods: {
    normalizeTo(to) {
      return withTrailingSlash(to);
    },
  },
  components: { ContentBlocks },
  props: {
    introParts: {
      type: Array,
      required: true,
    },
    bannerSrc: {
      type: String,
      default: '',
    },
    bannerAlt: {
      type: String,
      default: '',
    },
    blocks: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
